<div class="decision-page">
  <section class="decision-panel" aria-live="polite">
    <ng-container *ngIf="isLoading; else decisionResult">
      <p>Processing registration request...</p>
    </ng-container>

    <ng-template #decisionResult>
      <mat-icon
        class="decision-icon"
        [class.decision-icon--success]="isSuccess"
        [class.decision-icon--info]="isInfo"
        [class.decision-icon--error]="!isSuccess && !isInfo"
        aria-hidden="true"
      >
        {{ isSuccess ? 'check_circle' : isInfo ? 'info' : 'error' }}
      </mat-icon>

      <h1 class="ewrs-page-title">{{ heading }}</h1>
      <p>{{ message }}</p>

      <dl class="request-details" *ngIf="request">
        <div class="request-detail-row">
          <dt>Full name</dt>
          <dd>{{ request.fullName || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Email</dt>
          <dd>{{ request.email || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Reporting manager</dt>
          <dd>{{ request.reportingManager || request.managerEmail || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row">
          <dt>Division</dt>
          <dd>{{ request.division || 'Not available' }}</dd>
        </div>
        <div class="request-detail-row" *ngIf="request.delegates?.length">
          <dt>Delegates</dt>
          <dd>
            <span *ngFor="let delegate of request.delegates; let last = last">
              {{ delegate.name || delegate.email }}<span *ngIf="!last">, </span>
            </span>
          </dd>
        </div>
      </dl>

      <button mat-raised-button color="primary" type="button" (click)="goHome()">Go to EWRS</button>
    </ng-template>
  </section>
</div>
